import { ChangeDetectionStrategy, Component, computed, inject, input, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { EffyButtonComponent, EffyButtonSize, EffyButtonStyle } from '@effy-tech/angular-common/button';
import { ICtaLink } from './cta-button';

@Component({
  selector: 'nscf-header-cta-button',
  templateUrl: './cta-button.component.html',
  styleUrls: ['./cta-button.component.scss'],
  imports: [EffyButtonComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    ngSkipHydration: 'true',
  },
})
export class CtaButtonComponent {
  private readonly sanitizer = inject(DomSanitizer);

  readonly ctaLink = input.required<ICtaLink>();
  readonly buttonStyle = input<EffyButtonStyle>(EffyButtonStyle.PRIMARY);

  protected readonly EffyButtonSize = EffyButtonSize;
  protected readonly url = computed(() => this.sanitizeUrl(this.ctaLink()?.url));
  protected readonly title = computed(() => this.sanitizeHtml(this.ctaLink()?.title));

  private sanitizeUrl(url: string | null) {
    return this.sanitizer.sanitize(SecurityContext.RESOURCE_URL, this.sanitizer.bypassSecurityTrustResourceUrl(url));
  }

  private sanitizeHtml(html: string | null) {
    return this.sanitizer.sanitize(SecurityContext.HTML, this.sanitizer.bypassSecurityTrustHtml(html));
  }
}
